<script>
    import { getContext } from "svelte";
    import {
        api_info,
        getDraftRequest,
        submitApproveRequest,
    } from "../api/client.js";
    import Tags from "../components/Tags.svelte";
    import Alert from "../components/Alert.svelte";
    import OrganizationDropDown from "../components/OrganizationDropDown.svelte";
    import { nextId } from "../components/id_generator.js";

    let loading = false;
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    let subject = "";
    let detail = "";
    let organization = "";
    let tags = [];
    let alertMsg = "";
    const context = getContext(api_info);
    async function initialize() {
        const response = await getDraftRequest(context, {
            id,
        });
        subject = response.subject;
        detail = response.detail;
        organization = response.type_name;
        tags = response.tags.map((x) => ({ id: nextId(), value: x }));
    }
    async function submit() {
        loading = true;
        const response = await submitApproveRequest(context, {
            id,
            subject,
            detail,
            tags: tags.map((x) => x.value),
            type_name: organization,
        });
        if (response.status === true) {
            alert("อนุมัติคำร้องแล้ว");
            location.href = "/admin/draftrequest/";
        } else {
            alertMsg = "ไม่สามารถอนุมัติคำร้องได้";
        }
        loading = false;
    }
    initialize();
</script>

<h2>ตรวจสอบคำร้อง</h2>
<form id="user_form">
    <div class="form-group">
        <label for="subject">หัวข้อคำร้อง</label>
        <input
            type="text"
            class="form-control"
            id="subject"
            name="subject"
            placeholder="ใส่หัวข้อคำร้องที่นี่"
            bind:value={subject}
        />
    </div>
    <div class="form-group">
        <label for="detail">รายละเอียดคำร้อง</label>
        <textarea
            rows="8"
            class="form-control"
            id="detail"
            name="detail"
            placeholder="ใส่รายละเอียดคำร้องที่นี่"
            bind:value={detail}
        />
    </div>

    {#if organization}
        <div class="form-horizontal tagging">
            <div class="form-group">
                <label class="col-sm-2 control-label" for="organization"
                    >หน่วยงาน</label
                >
                <div class="col-sm-10">
                    <OrganizationDropDown
                        bind:value={organization}
                        id="organization"
                    />
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label" for="tags"
                    >ป้ายกำกับ</label
                >
                <div class="col-sm-10">
                    <Tags bind:tags minTags={1} id="tags" dragDisabled={true} />
                </div>
            </div>
            <button
                type="button"
                class="btn btn-primary"
                on:click={submit}
                disabled={loading}>Approve</button
            >
        </div>
    {/if}
    <Alert bind:alertMsg type="danger" />
</form>

<style>
    .tagging {
        padding-top: 20px;
        padding-bottom: 20px;
    }
</style>
